import { memo } from "react";

import { QuestionPlanRoomChangeDisable as Question } from "@/components/features/items/edit/plan/_shared/ui/components/room-change-disable";

import { usePlanRoomChangeDisable } from "./hooks";

export const QuestionPlanRoomChangeDisable = memo(() => {
	const { roomChangeDisable, onSetRoomChangeDisable } = usePlanRoomChangeDisable();

	return <Question roomChangeDisable={roomChangeDisable} onSetRoomChangeDisable={onSetRoomChangeDisable} />;
});

QuestionPlanRoomChangeDisable.displayName = "QuestionPlanRoomChangeDisable";
